import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';

import { Checkbox } from '@mui/material';
import { CommunicationDTO as CommunicationType } from '../../../../business/models/dto/svs/svs.dto';
import { Dispatch } from 'redux';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './svs.module.css';
import { tabCommunicationFieldChange } from '../../../../store/details/svs/actions';
import { validateEmail } from '../../../../store/shared/actions';
import { Company, Role } from '../../../../store/shared/model';

interface PropsFromDispatch {
  readonly tabCommunicationFieldChange: typeof tabCommunicationFieldChange;
  readonly validateEmail: typeof validateEmail;
}

interface PropsFromState {
  readonly data: CommunicationType;
  readonly emailEnteredButNotCheckedWarning: boolean;
  readonly locked: boolean;
  readonly isBelfiusParentCompany: boolean;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class Communication extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    return (
      <div>
        <div className={styles.content}>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.checkbox}>
                <Checkbox
                  checked={this.props.data.sendEmailToPolicyHolder}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    if (!this.props.locked) {
                      this.props.tabCommunicationFieldChange({ ...this.props.data, sendEmailToPolicyHolder: event.target.checked });
                    }
                  }}
                  value='true' />
                {this.localization.get('details.svs.communication.sendEmailToPolicyHolder')}
              </div>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.svs.communication.emailPolicyHolder')}
                value={this.props.data.emailPolicyHolder ? this.props.data.emailPolicyHolder : ''}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.tabCommunicationFieldChange({ ...this.props.data, emailPolicyHolder: event.target.value });
                }}
                onBlur={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.validateEmail(event.target.value);
                }} />
              {this.props.isBelfiusParentCompany ?
              <div className={styles.checkboxDacca}>
                <Checkbox
                  disabled={this.props.locked || !this.props.data.sendEmailToPolicyHolder}
                  checked={this.props.data.sendDaccaEmailToPolicyHolder}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.props.tabCommunicationFieldChange({ ...this.props.data, sendDaccaEmailToPolicyHolder: event.target.checked });
                  }}
                  value='true' />
                <img alt="" className={styles.daccaIcon} src={require('../../../../assets/images/dacca_with_calculation_85x85.png')} />
              </div> : '' }

            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.checkbox}>
                <Checkbox
                  checked={this.props.data.sendEmailToCounterExpert}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    if (!this.props.locked) {
                      this.props.tabCommunicationFieldChange({ ...this.props.data, sendEmailToCounterExpert: event.target.checked });
                    }
                  }}
                  value='true' />
                {this.localization.get('details.svs.communication.sendEmailToCounterExpert')}
              </div>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.svs.communication.emailCounterExpert')}
                value={this.props.data.emailCounterExpert ? this.props.data.emailCounterExpert : ''}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.tabCommunicationFieldChange({ ...this.props.data, emailCounterExpert: event.target.value });
                }}
                onBlur={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.validateEmail(event.target.value);
                }} />
              {this.props.isBelfiusParentCompany ?
              <div className={styles.checkboxDacca}>
                <Checkbox
                  disabled={this.props.locked || !this.props.data.sendEmailToCounterExpert}
                  checked={this.props.data.sendDaccaEmailToCounterExpert}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.props.tabCommunicationFieldChange({ ...this.props.data, sendDaccaEmailToCounterExpert: event.target.checked });
                  }}
                  value='true' />
                <img alt="" className={styles.daccaIcon} src={require('../../../../assets/images/dacca_with_calculation_85x85.png')} />
              </div> : '' }
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.checkbox}>
                <Checkbox
                  checked={this.props.data.sendEmailToPersonalExpert}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    if (!this.props.locked) {
                      this.props.tabCommunicationFieldChange({ ...this.props.data, sendEmailToPersonalExpert: event.target.checked });
                    }
                  }}
                  value='true' />
                {this.localization.get('details.svs.communication.sendEmailToPersonalExpert')}
              </div>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.svs.communication.emailPersonalExpert')}
                value={this.props.data.emailPersonalExpert ? this.props.data.emailPersonalExpert : ''}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.tabCommunicationFieldChange({ ...this.props.data, emailPersonalExpert: event.target.value });
                }}
                onBlur={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.validateEmail(event.target.value);
                }} />
              {this.props.isBelfiusParentCompany ?
              <div className={styles.checkboxDacca}>
                <Checkbox
                  disabled={this.props.locked || !this.props.data.sendEmailToPersonalExpert}
                  checked={this.props.data.sendDaccaEmailToPersonalExpert}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.props.tabCommunicationFieldChange({ ...this.props.data, sendDaccaEmailToPersonalExpert: event.target.checked });
                  }}
                  value='true' />
                <img alt="" className={styles.daccaIcon} src={require('../../../../assets/images/dacca_with_calculation_85x85.png')} />
              </div> : '' }
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.checkbox}>
                <Checkbox
                  checked={this.props.data.sendEmailToOther}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    if (!this.props.locked) {
                      this.props.tabCommunicationFieldChange({ ...this.props.data, sendEmailToOther: event.target.checked });
                    }
                  }}
                  value='true' />
                {this.localization.get('details.svs.communication.sendEmailToOther')}
              </div>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.svs.communication.emailOther')}
                value={this.props.data.emailOther ? this.props.data.emailOther : ''}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.tabCommunicationFieldChange({ ...this.props.data, emailOther: event.target.value });
                }}
                onBlur={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.validateEmail(event.target.value);
                }} />
              {this.props.isBelfiusParentCompany ?
              <div className={styles.checkboxDacca}>
                <Checkbox
                  disabled={this.props.locked || !this.props.data.sendEmailToOther}
                  checked={this.props.data.sendDaccaEmailToOther}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.props.tabCommunicationFieldChange({ ...this.props.data, sendDaccaEmailToOther: event.target.checked });
                  }}
                  value='true' />
                <img alt="" className={styles.daccaIcon} src={require('../../../../assets/images/dacca_with_calculation_85x85.png')} />
              </div> : '' }
            </div>
          </div>
          {this.props.emailEnteredButNotCheckedWarning &&
            <div className={`${styles.row} ${styles.warning}`} >
              {this.localization.get('details.svs.communication.emailHasValueButNotChecked')}
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsSvs }, shared, caseState: { selectedCase } }: ApplicationState): PropsFromState => ({
  data: {
    sendEmailToPolicyHolder: detailsSvs.communication.sendEmailToPolicyHolder,
    emailPolicyHolder: detailsSvs.communication.emailPolicyHolder,
    sendEmailToCounterExpert: detailsSvs.communication.sendEmailToCounterExpert,
    emailCounterExpert: detailsSvs.communication.emailCounterExpert,
    sendEmailToPersonalExpert: detailsSvs.communication.sendEmailToPersonalExpert,
    emailPersonalExpert: detailsSvs.communication.emailPersonalExpert,
    sendEmailToOther: detailsSvs.communication.sendEmailToOther,
    emailOther: detailsSvs.communication.emailOther,
    sendDaccaEmailToPolicyHolder: detailsSvs.communication.sendDaccaEmailToPolicyHolder,
    sendDaccaEmailToCounterExpert: detailsSvs.communication.sendDaccaEmailToCounterExpert,
    sendDaccaEmailToPersonalExpert: detailsSvs.communication.sendDaccaEmailToPersonalExpert,
    sendDaccaEmailToOther: detailsSvs.communication.sendDaccaEmailToOther,
    sent: detailsSvs.communication.sent
  },
  locked: detailsSvs.communication.sent || selectedCase.blocked || !shared.roles.includes(Role.ExFiLoAd),
  emailEnteredButNotCheckedWarning:
    (!detailsSvs.communication.sendEmailToPolicyHolder && detailsSvs.communication.emailPolicyHolder !== null && detailsSvs.communication.emailPolicyHolder.trim() !== '') ||
    (!detailsSvs.communication.sendEmailToCounterExpert && detailsSvs.communication.emailCounterExpert !== null && detailsSvs.communication.emailCounterExpert.trim() !== '') ||
    (!detailsSvs.communication.sendEmailToPersonalExpert && detailsSvs.communication.emailPersonalExpert !== null && detailsSvs.communication.emailPersonalExpert.trim() !== '') ||
    (!detailsSvs.communication.sendEmailToOther && detailsSvs.communication.emailOther !== null && detailsSvs.communication.emailOther.trim() !== ''),
    isBelfiusParentCompany: shared.parentPartyDibCode === Company.Belfius,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  tabCommunicationFieldChange: (data: CommunicationType) => dispatch(tabCommunicationFieldChange(data)),
  validateEmail: (email: string) => dispatch(validateEmail(email))
});

export default connect(mapStateToProps, mapDispatchToProps)(Communication);
